import React from 'react'
import Manager from '../../public/components/Manager'
import OverTimeApplyDetail from './OverTimeApplyDetail'
import { doOverTimeApplyAction } from '../../business/OverTimeApplyAction'

Ext.require('Ext.Toast')

const config = props => {
	return {
		tabs: {
			'申请中': {
				buttons: [
					{ text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <OverTimeApplyDetail {...props} id={0} />) },
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, },
					{ _text: '加班折算方式', field: 'ConversionMode', minWidth: 150, search: true, filter: ['select'], },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 150, filter: true, align: 'left', },
					{ _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
					{ _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
					{ _text: '加班原因', field: 'Reason', minWidth: 150, search: true, flex: 10 },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <OverTimeApplyDetail {...props} id={data.id} />)
				}
			},
			'填写中': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, },
					{ _text: '加班折算方式', field: 'ConversionMode', minWidth: 150, search: true, filter: ['select'], },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 150, filter: true, align: 'left', },
					{ _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
					{ _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
					{ _text: '加班原因', field: 'Reason', minWidth: 150, flex: 10, search: true },
					{ _: 'taskName', field: '_TaskName' }
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <OverTimeApplyDetail {...props} id={data.id} taskName={data.taskName} />)
				}
			},
			'驳回申请': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, },
					{ _text: '加班折算方式', field: 'ConversionMode', minWidth: 150, search: true, filter: ['select'], },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 150, filter: true, align: 'left', },
					{ _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
					{ _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
					{ _text: '加班原因', field: 'Reason', minWidth: 150, flex: 10, search: true },
					{ _: 'taskName', field: '_TaskName' }
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <OverTimeApplyDetail {...props} id={data.id} taskName={data.taskName} />)
				}
			},
			'签核中': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, },
					{ _text: '加班折算方式', field: 'ConversionMode', minWidth: 150, search: true, filter: ['select'], },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 150, filter: true, align: 'left', },
					{ _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
					{ _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
					{ _text: '加班原因', field: 'Reason', minWidth: 150, search: true, flex: 10 },
					{ _text: '当前操作人', minWidth: 150, search: true, flex: 10 },
					{ _: '状态名称' },
					// {
					//     _button: '驳回申请', icon: 'reply', ui: 'action decline alt', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
					//         doOverTimeApplyAction(props.dispatch, '驳回申请', { id: data.id, action: `${data.状态名称}.退回申请`, onSave: refreshPage, showDetail: showDetail })
					//     }
					// },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <OverTimeApplyDetail {...props} id={data.id} readOnly={true} />)
				}
			},
			'已完成': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, },
					{ _text: '加班折算方式', field: 'ConversionMode', minWidth: 150, search: true, filter: ['select'], },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 150, filter: true, align: 'left', },
					{ _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
					{ _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
					{ _text: '加班原因', field: 'Reason', minWidth: 150, flex: 10, search: true },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <OverTimeApplyDetail {...props} id={data.id} />)
				}
			}
		}
	}
}

export default props => <Manager {...props} config={config} />